<template>
  <div class="main">
    <a-modal
      v-model="visible"
      :title="title"
      width="20cm"

      :maskClosable="false"
      @ok="handleSubmit"
    >
      <a-form
        id="formLogin"
        class="user-layout-login"
        ref="formLogin"
        :form="form"
      >
        <div class="margin">

          <a-form-item label="工号" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
            <a-input
              size="large"
              type="text"
              placeholder="账户"
              v-decorator="[
                'username',
                {rules: [{ required: true, message: '请输入帐户名' }],
                 validateTrigger: 'change',
                 initialValue: operator.no
                }
              ]"
            >
              <a-icon slot="prefix" :style="{ color: 'rgba(0,0,0,.25)' }" type="user"/>
            </a-input>
          </a-form-item>

          <a-form-item label="密码" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
            <a-input
              size="large"
              type="password"
              autocomplete="false"
              placeholder="密码"
              v-decorator="[
                'password',
                {rules: [{ required: true, message: '请输入密码' }], validateTrigger: 'blur'}
              ]"
            >
              <a-icon slot="prefix" :style="{ color: 'rgba(0,0,0,.25)' }" type="lock"/>
            </a-input>
          </a-form-item>

          <a-form-item label="时间" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
            <a-input
              size="large"
              type="text"
              placeholder="时间"
              disabled
              v-decorator="[
                'time',
                {rules: [{ required: true}],
                 initialValue: time
                }
              ]"
            >
              <a-icon slot="prefix" :style="{ color: 'rgba(0,0,0,.25)' }" type="clock-circle"/>
            </a-input>
          </a-form-item>
          <a-form-item label="签名原因" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
            <a-textarea
              disabled
              :style="{width:200}"
              :autosize="{
                minRows: 4,
                maxRows: 200
              }"
              :rows="4"
              v-decorator="[
                'reason',
                {rules: [{ required: true}],
                 initialValue: category.name
                }
              ]"
            />
          </a-form-item>
        </div>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import store from '@/store'
import { OPERATOR } from '@/store/mutation-types'
import Vue from 'vue'
import moment from 'moment'
import { SignatureLog } from '@/api/dto/log/SignatureLog'

export default {
  name: 'UnlockModal',
  props: {
    'title': { type: String, default: '签名' }
  },
  data() {
    return {
      customActiveKey: 'tab1',
      loginBtn: false,
      loginType: 0,
      isLoginError: false,
      form: this.$form.createForm(this),
      state: {
        time: 60,
        loginBtn: false,
        loginType: 0,
        smsSendBtn: false
      },
      no: '',
      visible: false,
      operator: Vue.ls.get(OPERATOR),
      time: moment().format('YYYY-MM-DD HH:MM:SS'),
      reason: '',
      click: '',
      button: '',
      router: '',
      log: '',
      notes: '',
      category: ''
    }
  },
  methods: {
    ...mapActions(['Verify']),
    handleSubmit(e) {
      e.preventDefault()
      const {
        form: { validateFields },
        state,
        customActiveKey
      } = this
      //state.loginBtn = true
      const that = this
      const validateFieldsKey = ['username', 'password', 'notes']
      validateFields(validateFieldsKey, { force: true }, (err, values) => {
        if (!err) {
          console.log('login form', values)
          const loginParams = { ...values }
          delete loginParams.username
          delete loginParams.notes
          loginParams['username'] = values.username
          loginParams.password = values.password //md5(values.password)
          loginParams.appname = 'DESKTOP'
          //this.notes = values.notes
          //this.no = loginParams.no
          //Object.assign(loginParams,this.no)
          store.dispatch('Verify', loginParams).then(res => {
            that.operator = res
            if (res.categories.findIndex(c => c.id === that.category.id) < 0) {
              this.$error({
                title: '没有权限',
                content: '输入的用户没有当前功能解锁权限'
              })
              return
            }
            that.click()
            that.loginSuccess(res)
          })
            .catch(err => {
              that.requestFailed(err)
              console.log(err, 'err')
            })
            .finally(() => {
              state.loginBtn = false
            })
        } else {
          setTimeout(() => {
            state.loginBtn = false
          }, 600)
        }
      })
    },
    loginSuccess(res) {
      this.log = new SignatureLog(undefined, this.operator.name, this.time, 1, this.reason, this.notes)
      this.log.save()
      console.log(res)
      this.isLoginError = false
      this.visible = false
    },
    requestFailed(err) {
      this.isLoginError = true
      this.$notification['error']({
        message: '错误',
        description: ((err.response || {}).data || {}).message || '请求出现错误，请稍后再试',
        duration: 4
      })
    }
  }
}
</script>

<style lang="less" scoped>
.user-layout-login {
  position: relative;
  text-align: center;
  top: 10px;

  label {
    font-size: 14px;
  }

  .getCaptcha {
    display: block;
    width: 100%;
    height: 40px;
  }

  .forge-password {
    font-size: 14px;
  }

  button.login-button {
    padding: 0 15px;
    font-size: 16px;
    height: 40px;
    width: 50%;
    //margin-left: 50%;
  }

  .user-login-other {
    text-align: left;
    margin-top: 14px;
    line-height: 22px;

    .item-icon {
      font-size: 24px;
      color: rgba(0, 0, 0, 0.2);
      margin-left: 16px;
      vertical-align: middle;
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: #1890ff;
      }
    }

    .register {
      float: right;
    }
  }

  .margin {
    margin: 0 30px 10px 30px;
    position: relative;
  }

  .title {
    font-size: 33px;
    /*color: rgba(0, 0, 0, .85);*/
    /*color: #1890ff;*/
    color: #FFFFFF;
    font-family: Avenir, 'Helvetica Neue', Arial, Helvetica, sans-serif;
    font-weight: 600;
    position: relative;
    top: 10px;
    bottom: 40px;
  }
}
</style>
